<header class="admin-header">
  <div class="admin-header__brand" [class.admin-header__brand--collapsed]="sidebarService.collapsed()">
    <button type="button" class="admin-header__menu-btn" (click)="toggleSidebar($event)" aria-label="Toggle sidebar">
      <span></span><span></span><span></span>
    </button>
    <a [routerLink]="routes.DASHBOARD" class="admin-header__logo-link">
      <img src="/assets/images/logo3.png" alt="Amaalmomineen - Your Companion in Imaan" class="admin-header__logo" />
    </a>
  </div>

  <div class="admin-header__search">
    <span class="admin-header__search-icon" aria-hidden="true">🔍</span>
    <input type="search" placeholder="Search anything..." class="admin-header__search-input" />
    <button type="button" class="admin-header__search-btn" aria-label="Search">🔍</button>
  </div>

  <div class="admin-header__actions">
    <div class="admin-header__date">
      <span class="admin-header__date-icon" aria-hidden="true">📅</span>
      <div class="admin-header__date-text">
        <span>Hijri {{ islamicDate.hijri }}</span>
        <span>{{ islamicDate.gregorian }} | {{ islamicDate.weekday }}</span>
      </div>
    </div>

    <!-- Language Switcher -->
    <div class="admin-header__lang-menu">
      <button type="button" class="admin-header__lang-btn" [attr.aria-label]="'header.choose_language' | translate" (click)="toggleLangMenu()">
        <span>{{ languageService.currentLanguage().flag }}</span>
        <span class="admin-header__lang-code">{{ languageService.currentLang().toUpperCase() }}</span>
        <span>▾</span>
      </button>
      @if (langMenuOpen()) {
        <div class="admin-header__lang-dropdown">
          <span class="admin-header__lang-dropdown-title">{{ 'header.choose_language' | translate }}</span>
          @for (lang of languageService.languages; track lang.code) {
            <button
              type="button"
              class="admin-header__lang-option"
              [class.admin-header__lang-option--active]="lang.code === languageService.currentLang()"
              (click)="selectLanguage(lang.code)">
              <span>{{ lang.flag }}</span>
              <span class="admin-header__lang-label">{{ 'languages.' + lang.code | translate }}</span>
              @if (lang.code === languageService.currentLang()) {
                <span class="admin-header__lang-check">✓</span>
              }
            </button>
          }
        </div>
      }
    </div>

    <!-- Theme Switcher -->
    <div class="admin-header__theme-menu">
      <button type="button" class="admin-header__icon-btn" aria-label="Switch theme" (click)="toggleThemeMenu()">
        🎨
      </button>
      @if (themeMenuOpen()) {
        <div class="admin-header__theme-dropdown">
          <span class="admin-header__theme-dropdown-title">Choose Theme</span>
          @for (theme of themeService.themes; track theme.id) {
            <button
              type="button"
              class="admin-header__theme-option"
              [class.admin-header__theme-option--active]="themeService.currentTheme() === theme.id"
              (click)="selectTheme(theme.id)">
              <span class="admin-header__theme-swatch" [style.background]="theme.swatch"></span>
              <span class="admin-header__theme-label">{{ theme.label }}</span>
              @if (themeService.currentTheme() === theme.id) {
                <span class="admin-header__theme-check">✓</span>
              }
            </button>
          }
        </div>
      }
    </div>

    <div class="admin-header__notif">
      <button type="button" class="admin-header__icon-btn" aria-label="Notifications" (click)="toggleNotifMenu()">
        🔔
        @if (notificationService.unreadCount() > 0) {
          <span class="admin-header__badge">{{ notificationService.unreadCount() }}</span>
        }
      </button>
      @if (notifMenuOpen()) {
        <div class="admin-header__notif-dropdown">
          <div class="admin-header__notif-header">
            <span class="admin-header__notif-title">Notifications</span>
            @if (notificationService.unreadCount() > 0) {
              <button type="button" class="admin-header__notif-mark-all" (click)="notificationService.markAllRead()">
                Mark all read
              </button>
            }
          </div>
          <div class="admin-header__notif-list">
            @for (notif of notificationService.notifications(); track notif.id) {
              <div class="admin-header__notif-item" [class.admin-header__notif-item--unread]="!notif.read" (click)="notificationService.markRead(notif.id)">
                <span class="admin-header__notif-icon" [style.background]="notificationService.categoryMeta[notif.category].color">
                  {{ notificationService.categoryMeta[notif.category].icon }}
                </span>
                <div class="admin-header__notif-body">
                  <span class="admin-header__notif-category" [style.color]="notificationService.categoryMeta[notif.category].color">
                    {{ notificationService.categoryMeta[notif.category].label }}
                  </span>
                  <p class="admin-header__notif-message">{{ notif.message }}</p>
                  <span class="admin-header__notif-time" [title]="notificationService.formatDateTime(notif.time)">
                    {{ notificationService.formatTime(notif.time) }}
                  </span>
                </div>
                @if (!notif.read) {
                  <span class="admin-header__notif-dot"></span>
                }
              </div>
            } @empty {
              <div class="admin-header__notif-empty">No notifications</div>
            }
          </div>
        </div>
      }
    </div>

    <div class="admin-header__user-menu">
      <button type="button" class="admin-header__user" (click)="toggleUserMenu()" aria-label="Profile menu">
        <span class="admin-header__user-avatar">{{ userInitials() }}</span>
      </button>
      @if (userMenuOpen()) {
        <div class="admin-header__user-dropdown">
          <span class="admin-header__user-dropdown-name">
            {{ authService.isAuthenticated() ? (authService.userName() || 'User') : 'Guest Profile' }}
          </span>
          @if (authService.isAuthenticated()) {
            <a [routerLink]="routes.DASHBOARD_SETTINGS" (click)="userMenuOpen.set(false)">
              <span aria-hidden="true">👤</span> Profile
            </a>
            <a [routerLink]="routes.DASHBOARD_SETTINGS" (click)="userMenuOpen.set(false)">
              <span aria-hidden="true">⚙️</span> Settings
            </a>
            <button type="button" (click)="logout()">
              <span aria-hidden="true">↪</span> Logout
            </button>
          } @else {
            <a [routerLink]="routes.AUTH.LOGIN" (click)="userMenuOpen.set(false)">
              <span aria-hidden="true">↪</span> Login
            </a>
          }
        </div>
      }
    </div>
  </div>
</header>
